import React, { useState, useEffect } from "react";
import { FaInfoCircle } from "react-icons/fa";
import AllegatoAccordion from "./AllegatoAccordion"; // Assicurati di importare il componente AllegatoAccordion
import { Tooltip as ReactTooltip } from "react-tooltip"; // Importazione aggiornata
import tooltip from "../data/tooltip"
import staticText from "../data/staticText"
import { generatePdfBlob } from "../utils/pdfUtils"; // Adjust path if needed
import PdfFormFiller from "../components/PdfTemplate"; // Adjust path if needed

const LastPage = ({ formData, setFormData, onCodeValidation, errors_, validateFields }) => {

  const [showAllegato, setShowAllegato] = useState(false);
  const [errors, setErrors] = useState({});
  const [isRequired, setIsRequired] = useState(true);
  const [uniqueCodeSent, setUniqueCodeSent] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [randomCode, setRandomCode] = useState(null); // Store the random code
  const [cooldownTime, setCooldownTime] = useState(0);
  const isButtonDisabled = !formData.profCli.trim() || !formData.luogoForm.trim();

  useEffect(() => {
    // Quando formData.authCode cambia, aggiorniamo authCodeValues con i valori del codice
    if (formData.authCode) {
      // Assicuriamoci che authCodeValues abbia sempre 6 celle, anche se formData.authCode è più corto
      const newAuthCodeValues = formData.authCode.split("").slice(0, 6);
      const filledValues = newAuthCodeValues.concat(new Array(6 - newAuthCodeValues.length).fill(""));
      setAuthCodeValues(filledValues);
    }
  }, [formData.authCode]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAllegato = () => {
    setShowAllegato((prevState) => !prevState);
  };

  const currentDate = new Date().toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });


  // const [pdfBlob, setPdfBlob] = useState(null);
  // const [generatePdf, setGeneratePdf] = useState(false);

  // const handleGeneratePdf = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const pdfBlob = await generatePdfBlob(formData);
  //     setPdfBlob(pdfBlob);

  //     setGeneratePdf(true);
  //   } catch (error) {
  //     console.error("Failed to generate PDF:", error);
  //   }
  // };

  //AUTH CODE

  const [authCodeValues, setAuthCodeValues] = useState(["", "", "", "", "", ""]);
  const generateRandomCode = async () => {
    try {

      setAuthCodeValues(new Array(authCodeValues.length).fill(""));
      setIsCodeValid(false); 
      
      // Step 1: Fetch the authentication code
      const response = await fetch('https://meetingartreg-backend.onrender.com/api/code');
      const data = await response.json();
      const code = data.authCode;

      // Step 2: Save the code (state or database as needed)
      setRandomCode(code);
      // console.log("Generated Random Code:", code);
      setFormData((prevData) => ({
        ...prevData,
        randomCode: code, // Save in formData
        authCode: "",
      }));
      
      const emailResponse = await fetch('https://meetingartreg-backend.onrender.com/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: formData.email,
          subject: formData.nationality === "it" ? "Meeting Art - Codice di Autenticazione" : "Meeting Art - Authentication Code",
          text: '',
          code,
          emailType: 'authentication',
        }),
      });

      if (!emailResponse.ok) {
        throw new Error("Failed to send email");
      }

      //console.log("Email sent successfully to:", formData.email);
    } catch (error) {
      console.error("Error in generateRandomCode:", error);
    }
  };



  // Handle the input change for the authCode field
  const handleChangeAuthCode = (e, index) => {
    const { value } = e.target;
    const updatedValues = [...authCodeValues];

    updatedValues[index] = value.slice(0, 1);
    setAuthCodeValues(updatedValues);

    if (value.length === 1 && index < updatedValues.length - 1) {
      const nextInput = document.getElementById(`authCode${index + 2}`);
      if (nextInput) nextInput.focus();
    }

    const newAuthCode = updatedValues.join("");

    // Validate against the stored randomCode
    if (newAuthCode.length === authCodeValues.length) {
      onCodeValidation(newAuthCode === formData.randomCode?.toString());
    } else {
      onCodeValidation(false);
    }

    setFormData((prevData) => ({
      ...prevData,
      authCode: newAuthCode,
    }));
  };



  // Handle the backspace key to move focus to the previous input
  const handleKeyDownAuthCode = (e, index) => {
    const totalFields = authCodeValues.length;

    // Prevent the default Tab/Enter behavior to control focus manually
    if (e.key === "Tab" || e.key === "Enter") {
      e.preventDefault(); // Stop the default behavior of jumping to the next field

      // Move to the next input if it's not the last one
      if (index < totalFields - 1) {
        const nextInput = document.getElementById(`authCode${index + 2}`);
        if (nextInput) nextInput.focus();
      }
    }

    // Handle Backspace key (move to previous input if current field is empty)
    if (e.key === "Backspace" && authCodeValues[index] === "" && index > 0) {
      const prevInput = document.getElementById(`authCode${index}`);
      if (prevInput) prevInput.focus();
    }
  };



  // CLICK DEL BOTTONE CON COOLDOWN
  const handleAuthCodeButtonClick = () => {
    if (isSending) return;

    setIsSending(true);
    setCooldownTime(90);

    generateRandomCode();

    const interval = setInterval(() => {
      setCooldownTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          setIsSending(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };



  useEffect(() => {
    if (formData.randomCode) {
      setRandomCode(formData.randomCode); // Restore the previous random code
    }
  }, []);


  return (

    <div>

      <div className="mb-4 mt-20 mx-auto">
        <p className="font-bold mb-10" style={{ whiteSpace: "pre-line" }}>
          {staticText[formData.nationality]?.authCodePar1}<u>{formData.email}</u>.<br />{staticText[formData.nationality]?.authCodePar2}
        </p>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleAuthCodeButtonClick} // On button click, trigger the random code generation
            className={`px-4 py-2 rounded-md mt-2 mb-10 ${isSending || isButtonDisabled
                ? "bg-gray-400 cursor-not-allowed"
                : "primary-color text-white"
              }`}
            disabled={isSending}
          >
            {isSending ? `Controllare la propria mail e attendere ${cooldownTime}s... prima di reinviare il codice` : staticText[formData.nationality]?.inviaCode}
          </button>
        </div>

        <div className="mb-4">
          { /*BUTTON FOR DEBUG MODE*/}
          {/* <button type="button" onClick={handleGeneratePdf}>Trigger Event</button>
      {generatePdf && <PdfFormFiller pdfBlob={pdfBlob} setGeneratePdf={setGeneratePdf} />}  */}

          <label className="block text-center text-gray-700 font-bold mb-2">
            {staticText[formData.nationality]?.insertCode}  </label>
          <div className="flex gap-2 justify-center items-center">
            {authCodeValues.map((value, index) => (
              <input
                key={index}
                id={`authCode${index + 1}`}
                name={`authCode${index + 1}`}
                type="text"
                value={value} // Set value for each input field
                onChange={(e) => handleChangeAuthCode(e, index)} // Update value on change
                onKeyDown={(e) => handleKeyDownAuthCode(e, index)} // Handle backspace
                maxLength={1}
                className="w-12 h-12 text-center text-xl border border-gray-300 rounded-md focus:ring focus:ring-blue-400"
              />
            ))}
          </div>
          <p className="mt-2 text-sm text-gray-500 text-center">
            {staticText[formData.nationality]?.insertCode2}
          </p>
        </div>
      </div>
    </div>
  );

};

export default LastPage;
